import {
  AgentExecutionStatusSchema,
  ArtifactSchema,
  TraceFileSchema,
} from '@terra/shared-schemas-ai';
import { BaseSignalDtoSchema } from '@terra/shared-contracts-signals';
import { z } from 'zod';
import { PlanItemSchema } from './agent-execution.schema';

export const ExecutionEvidenceSchema = z.object({
  artifactId: z.string(),
  description: z.string(),
});

export const AgentExecutionHistoryResponseSchema = z.object({
  executionId: z.string(),
  status: AgentExecutionStatusSchema,
  summary: z.string().nullable(),
  evidences: z.array(ExecutionEvidenceSchema).optional(),
  messages: z.array(z.unknown()),
  files: z.array(TraceFileSchema),
  artifacts: z.array(ArtifactSchema),
  plan: z.array(PlanItemSchema),
  signalId: z.string().nullable().optional(),
  signal: BaseSignalDtoSchema.nullable().optional(),
});

export type AgentExecutionHistoryResponseDto = z.infer<
  typeof AgentExecutionHistoryResponseSchema
>;
